import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import LoadableComponent from '@/components/LoadableComponent'

const frontend = [
  <Route key="/" path="/" exact component={LoadableComponent(lazy(() => import('./Index')))}/>,
  <Route key="/home" path="/home" exact component={LoadableComponent(lazy(() => import('./Home')))}/>,
  <Route key="/login" path="/login" exact component={LoadableComponent(lazy(() => import('./Login')))}/>,
  <Route key="/backend" path="/backend" component={LoadableComponent(lazy(() => import('./backend/wrapper')))}/>,
  <Route key={"/memberLayout"} path={"/ml"} component={LoadableComponent(lazy(() => import('./example/member')))}/>,
  <Route key={"/webLayout"} path={"/wl"} component={LoadableComponent(lazy(() => import('./example/webPage/Index')))}/>,
  <Route key={"/pl"} path={"/pl"}
         component={LoadableComponent(lazy(() => import('./example/productList/productList')))}/>,
  <Route key={"/member"} path={"/member"} component={LoadableComponent(lazy(() => import('./member/index')))}/>,
  <Route key={"/select"} path={"/select"} component={LoadableComponent(lazy(() => import('./Select/index')))}/>,
  <Route key={"/items/search"} path={"/items/:nameLi"}
         component={LoadableComponent(lazy(() => import('./Items/index')))}/>,
  <Route key={"/logistics"} path={"/logistics"}
         component={LoadableComponent(lazy(() => import('./Logistics/index')))}/>,
  <Route key={"/storage"} path={"/storage"} component={LoadableComponent(lazy(() => import('./Storage/index')))}/>,
  <Route key={"/finance"} path={"/finance"} component={LoadableComponent(lazy(() => import('./Finance/index')))}/>,
  <Route key={"/items"} path={"/items"} component={LoadableComponent(lazy(() => import('./Items/index')))}/>,
  <Route key={"/shoppingCart"} path={"/shoppingCart"} component={LoadableComponent(lazy(() => import('./cart')))}/>,
  <Route key={"/pay"} path={"/pay"} component={LoadableComponent(lazy(() => import('./pay/Pay')))}/>,
  <Route key={"/payResult"} path={"/payResult"}
         component={LoadableComponent(lazy(() => import('./result/PayResult')))}/>,
  <Route key={"/details"} path={"/details/:productId"}
         component={LoadableComponent(lazy(() => import('./Details/Details')))}/>,
  <Route key="/register" path="/register" exact component={LoadableComponent(lazy(() => import('./Register')))}/>,
  <Route key="/merchantReg" path="/merchantReg" exact
         component={LoadableComponent(lazy(() => import('./MerchantReg')))}/>,
  <Route key="/merchantMall" path="/merchantMall/:merchantId/:merchantName" exact
         component={LoadableComponent(lazy(() => import('./MerchantMall')))}/>,
]

export default frontend
